import useAxiosAuthentication from "@/compositions/useAxiosAuthentication";
import axios from "axios";
import { DEFAULT_HEADERS } from "@/compositions/useAxios/data.ts";

const axiosInstance = axios.create();
useAxiosAuthentication(axiosInstance);

const post = async (uploadPath: string, payload) => {
  const url = `${import.meta.env.VITE_API_BASE_URL}${uploadPath}`;
  let response = null;
  try {
    response = await axiosInstance.post<string>(url, payload, {
      headers: DEFAULT_HEADERS
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export default { post };
